import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { tagsDirectoryRoute } from '@townsquare/routes/tags-directory';
import { tqlExplainerResource } from '@townsquare/tql/resource';

import { exploreResource } from './resources/explore';

const TagsDirectory = Loadable({
  loader: () => import(/* webpackChunkName: "tags-directory" */ './ui/Explore'),
  loading: () => null,
});
tagsDirectoryRoute.component = TagsDirectory;
tagsDirectoryRoute.resources = [exploreResource, onboardingResource, tqlExplainerResource];

export const tagsDirectoryRouterRoute = tagsDirectoryRoute;
